import script from "./ShisetsuTaikenDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ShisetsuTaikenDetail.vue?vue&type=script&setup=true&lang=js"

import "./ShisetsuTaikenDetail.vue?vue&type=style&index=0&id=4ff9a910&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ff9a910"]])

export default __exports__